export default "__VITE_ASSET__Bg_klv0u__"